// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1KPQf","label":"SetPasswdForm_label__3D6cZ"};